import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
    navmenu: { userSelect: 'none', width: '100%' },
    trialButton: {
        width: 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        background: '#4519ef',
        padding: '8px 40px',
        color: '#fff !important',
        fontSize: '16px',
        borderRadius: '50px',
        marginLeft: 0,
        fontFamily: 'Poppins-SemiBold',
        '&:hover': {
            color: '#fff',
            background: '#3E15D7',
            borderRadius: '50px !important',
            boxShadow: '0px 0px 2px 0px rgba(145, 158, 171, 0.24), 0px 12px 24px 0px rgba(145, 158, 171, 0.24)'
        }
    },
    crownIcon: { marginTop: '3px', marginLeft: '10px' },
    tab: { color: '#595959', fontWeight: 700 },
    loginButton: {
        height: '42px',
        width: 'auto',
        marginRight: 0,
        overflow: 'hidden',
        padding: '8px 40px ',
        justifyContent: 'left',
        textTransform: 'none',
        border: '1px solid #4519EF',
        fontSize: '16px !important',
        color: '#4519EF !important',
        borderRadius: '50px !important',
        fontFamily: 'Poppins-SemiBold !important',
        '&:hover': {
            background: '#fff !important',
            boxShadow: '0px 0px 2px 0px rgba(145, 158, 171, 0.24), 0px 12px 24px 0px rgba(145, 158, 171, 0.24)'
        },
        '&:focus': {
            outline: 'none'
        },
        '& $span': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            whiteSpace: 'nowrap'
        }
    },
    menu: {
        backgroundColor: '#ffffff',
        zIndex: 100,
        height: '224px',
        width: '110%',
        left: '-35px',
        position: 'absolute',
        boxShadow: '0px 4px 11px -4px rgba(0, 0, 0, 0.2)'
    },
    ulist: {
        paddingLeft: '0',
        paddingTop: '27px',
        flexDirection: 'column',
        width: '450px',
        margin: '0 auto',
        listStyle: 'none',
        display: 'flex',
        flexWrap: 'wrap'
    },
    list: {
        lineHeight: '35px',
        fontSize: '16px',
        '&:hover': {
            color: '#824179'
        }
    },
    product: {
        display: 'none'
    },
    login_menu: {
        padding: '16px 20px',
        borderRadius: '8px',
        maxWidth: 'max-content',
        minWidth: '260px',
        right: '0',
        position: 'absolute',
        backgroundColor: '#ffffff',
        zIndex: 3,
        boxShadow: '0px 8px 16px 0px rgba(145, 158, 171, 0.24)',
        display: 'none'
    },
    menu_hr: { margin: '8px 0', borderTop: '1px solid #E9EDF1' },
    username: {
        color: '#333',
        fontSize: '16px',
        letterSpacing: 0,
        lineHeight: '26px',
        marginBottom: '4px',
        whiteSpace: 'nowrap',
        textTransform: 'capitalize',
        fontFamily: 'Poppins-SemiBold !important'
    },
    userPlan: {
        color: '#7F7F7F',
        fontSize: '12px',
        letterSpacing: '1.2px',
        textTransform: 'uppercase',
        fontFamily: 'Poppins-Bold',
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        '&:hover': { color: '#4519EF', opacity: 0.8 }
    },
    login_bottom: { display: 'grid', gap: '8px' },
    login_link: {
        color: '#333',
        fontSize: '16px',
        lineHeight: '26px',
        display: 'inline-flex',
        gap: '10px',
        cursor: 'pointer',
        fontFamily: 'Poppins-SemiBold !important',
        '&:hover': { color: '#4519EF', boxShadow: 'none', opacity: 0.8 }
    },
    category: {
        position: 'relative',
        '&:hover': {
            '& $product': {
                display: 'block'
            },
            '& $menu': {
                display: 'flex'
            },
            '& $login_menu': {
                display: 'block'
            }
        }
    },
    w_l: {
        width: '560px',
        left: '-384px'
    },
    h44: {
        height: '44px'
    },
    bgGray: {
        '&:hover': {
            backgroundColor: 'rgba(50, 12, 62, 0.08)'
        }
    },
    avatarWrapper: {
        '&:hover': { background: '#F4F6F8', borderRadius: '8px' },
        height: '44px',
        padding: '10px 18px 10px 8px',
        width: 'max-content',
        position: 'relative',
        userSelect: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        marginRight: '10px'
    },
    chevron: { fontSize: '22px', color: '#434242', marginLeft: '10px' },
    label: {
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontWeight: 700,
        paddingRight: '8px',
        maxWidth: '130px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'flex'
    },
    uppercase: {
        textTransform: 'uppercase'
    }
}));
//# sourceMappingURL=desktop.js.map